import React from "react";

function PerformanceBasedPricingModelIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M20.422 45L12 38.128l4.828-4.745a9.324 9.324 0 0110.002-2.016h5.943c.591 0 1.158.234 1.577.651a2.221 2.221 0 010 3.146 2.233 2.233 0 01-1.577.652H28.17a.739.739 0 00-.738.736.735.735 0 00.738.736h5.215a2.633 2.633 0 001.964-.88l5.622-6.396a2.317 2.317 0 014.022 1.389 2.305 2.305 0 01-.548 1.662l-7.02 8.153a5.508 5.508 0 01-4.151 1.882h-10.96L20.423 45zm3.403-22.394a1.157 1.157 0 00-1.152 1.149v3.972a1.151 1.151 0 001.152 1.15h2.56a1.157 1.157 0 001.152-1.15v-3.969a1.151 1.151 0 00-1.152-1.149l-2.56-.003zm13.105 6.27h2.56a1.157 1.157 0 001.146-1.149v-7.729a1.15 1.15 0 00-1.153-1.15H36.93a1.157 1.157 0 00-1.152 1.15v7.73a1.152 1.152 0 001.152 1.148zM29.225 13.15v14.578a1.151 1.151 0 001.152 1.15h2.56a1.157 1.157 0 001.153-1.15V13.15A1.15 1.15 0 0032.94 12h-2.56a1.157 1.157 0 00-1.156 1.15z"
            ></path>
        </svg>
    );
}

export default PerformanceBasedPricingModelIcon;
